import { render, staticRenderFns } from "./good-article-detail.vue?vue&type=template&id=b6299a8e&scoped=true&"
import script from "./good-article-detail.vue?vue&type=script&lang=js&"
export * from "./good-article-detail.vue?vue&type=script&lang=js&"
import style0 from "./good-article-detail.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./good-article-detail.vue?vue&type=style&index=1&id=b6299a8e&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6299a8e",
  null
  
)

export default component.exports